<template>
    <div class="">
        <el-popover
            ref="popover"
            placement="bottom"
            width="148"
            trigger="click"
            popper-class="dark-popper"
            @hide="hideSubscribePopover"
        >
            <div>
                <div class="popover-title">
                    <template v-if="broadcastRight">
                        CONFIRM REMOVE RIGHT (WARNING, THIS WILL STOP THE FEED FOR THIS TAKER)
                    </template>
                    <template v-else>
                        CONFIRM ADD RIGHT
                    </template>
                ?</div>
                <div class="actions">
                    <el-button type="text" class="decline" @click="hideSubscribePopover()">No</el-button>
                    <el-button type="text" class="accept" @click="changeRight()">Yes</el-button>
                </div>
            </div>
            <el-button
                slot="reference"
                :loading="loading"
                :disabled="disabledRightButton"
                type="primary"
                class="gcmcn-primary-btn small manage-right-btn"
                :class="{'has-right': broadcastRight, 'expanded' : popOverOpenned}"
                :icon="iconToDisplay"
                @click="popOverOpenned = true"
            >
            {{ textToDisplay }}</el-button>
        </el-popover>

    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        broadcastRight: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null,
        },
        feedConfirmed: {
            type: Boolean,
            required: true,
        },
        disabledRightButton: {
            type: Boolean,
            required: false,
            default: false
        },
    },

    data (){
        return {
            loading: false,
            popOverOpenned: false,
        };
    },

    computed: {
        iconToDisplay (){
            return this.broadcastRight === null ? 'ti-control-stop' : 'ti-check-box';
        },
        textToDisplay (){
            return this.broadcastRight === null ? 'Add right' : 'Remove right';
        },
    },
    mounted (){
        this.$eventBus.$on('broadcast-right-save-ended', () => {
            this.loading = false;
        });
    },

    beforeDestroy (){
        this.$eventBus.$off('broadcast-right-save-ended');
    },

    methods: {
        changeRight (){
            this.hideSubscribePopover();
            this.loading = true;
            this.$emit(this.broadcastRight ? 'delete-broadcast-right' : 'create-broadcast-right');
        },
        hideSubscribePopover() {
            this.popOverOpenned = false;
            if (this.$refs['popover']) {
                this.$refs['popover'].showPopper = false;
            }
        },
    },
};
</script>

<style lang="scss">
.manage-right-btn{
    width: 24px;
    i + span{
        display: none;
    }
    &:hover, &.expanded{
        width: 100px;
        &.has-right{
            width: 120px;
        }

        i + span{
            display: initial;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/manage-broadcast-right.vue